import { Link } from 'react-router';
import { StateBadge } from '../../../ui/Badge';
import { ActorName, Card } from '../../../ui/misc';
import type { ReleaseDetail } from '../types';

export function Approvals({ r }: { r: ReleaseDetail }) {
  return (
    <Card title="Approvals" tight>
      {r.approvals.length === 0 ? (
        <span className="small muted">None yet.</span>
      ) : (
        <ul className="checklist">
          {r.approvals.map((a) => (
            <li key={a.id} style={{ flexDirection: 'column', gap: 2 }}>
              <span>
                <Link to={`/approvals/${a.displayId}`} className="mono">
                  {a.displayId}
                </Link>{' '}
                · candidate {a.candidateNumber}{' '}
                <StateBadge
                  state={a.consumedAt ? 'released' : a.state}
                  label={a.consumedAt ? 'Used' : undefined}
                />
              </span>
              <span className="small muted">
                Requested by <ActorName actor={a.requester} />
                {a.decidedBy && (
                  <>
                    {' '}
                    · decided by <ActorName actor={a.decidedBy} />
                  </>
                )}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
